import { getConfig } from 'config/get-config.ts';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { Providers } from './Providers.tsx';
import { createUserManager, setUserManager } from './services/auth/AuthService.ts';

// admin and sidebar styles
import './styles/scss/admin/admin.scss';
import './styles/scss/sidebar/sidebar.scss';
import './styles/scss/sidenav/sidenav.scss';

// header
import './styles/scss/header/user-menu.component.scss';
import './styles/scss/header/user-profile-modal.component.scss';
import './styles/scss/search/deals.scss';

// react-datepicker
import 'react-datepicker/dist/react-datepicker.css';

import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './styles/scss/responsive.scss';

import './styles/scss/service-conquest/service-conquest.scss';

import './styles/scss/react.scss';

// css - must be last to import to overwrite other scss files
import './index.scss';

getConfig().then(() => {
  const userManager = createUserManager();
  setUserManager(userManager);

  createRoot(document.getElementById('root')!).render(
    <Providers userManager={userManager}>
      <App />
    </Providers>,
  );
});
